export default __webpack_public_path__ + "static/media/SR_Valentine.9ea1bb1e.png";